<template lang="pug">
div
  app-modal-despacho-presidente(
    v-if="openModalDespacho && idProcesso !== null && acaoAssinatura !== null",
    :idProcesso="idProcesso"
    :acao="acaoAssinatura"
    :setor='"PRESIDENTE"'
    :tituloModalDespacho="tituloModalDespacho"
    :tipoProcesso="tipoProcesso"
    @closeModal="openModalDespacho = false"
    @finalizar="finalizarModalDespachoAssinatura"
  )
  app-modal-assinar-titulo(
    v-if="showModalAssinatura",
    :idsProcessos="idsProcessosAssinatura",
    @closeModal="closeModalAssinatura",
    :tipo ="tipoSelecionado",
    :titulo="titleModal()"
    :isExtratoSentenca="situacao === 'AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA'"
    :isAssinarTodosReurbIndividual="isAssinarTodosReurbIndividual"
    :filtro="filtro"
  )

  app-modal-visualiza-pdf(
    v-if="showModalVisualizaPdf",
    @closeModal="closeModalVisualizaPdf",
    :titulo="tituloModal",
    :tipo="tipoTitulo",
    :conteudo="conteudoModal",
    :isProcesso="true"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )

  el-card.card-container(shadow="hover")
    filtro(
      :key="isEstadoMa() ? $route.name : 'filtro-static'",
      @pesquisar="pesquisar",
      @limpar="clear",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro",
      :showPesquisaAvancada="isEstadoMa() || isEstadoBa()",
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  div(class='list-table-container')
    app-listagem(
      :has-refresh-button="true",
      :showButtonOrdemServico="false",
      :showButtonAssinatura="!isEstadoMa()",
      :has-expansivel="false",
      :json-headers="colunas",
      :json-data="items",
      :totalElements="totalElements",
      :infoPrazos="infoPrazos",
      :pagina="filtro.pagina",
      :filtro="filtro",
      @updateListagem="limparAtualizarListagem",
      @changePage="changePage",
      @sort="sort",
      @executar="executar",
      @selected="false",
      @selectItem="selectItem",
      @selectAll="selectItems",
      @assinarTitulos="ASSINAR_TITULOS",
      @assinarTitulosGov="ASSINAR_TITULOS_GOV",
      :disableButtonAssinaturaTitulo="desativaBotao",
      @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise",
      :hasMultipleCheckbox="isMultiple() && showAssinarTitulo()",
      :showButtonAssinaturaGov="showButtonAssinaturaGov"
    )
    .buttons-assinatura
      div
        el-button(
          v-if="isEstadoMa() && this.showAssinarTodos()",
          @click="ASSINAR_TODOS_TITULOS",
          :disabled="desativaBotaoAssinarTodos"
        )
          span
            i.fa.fa-pager
            | &nbsp {{textoButtonAssinaturaTodos}}
        el-button(
          v-if="isEstadoMa() && showAssinarTitulo()",
          @click="ASSINAR_TITULOS",
          :disabled="desativaBotao"
        )
          span
            i.fa.fa-pager
            | &nbsp {{textoButtonAssinatura}}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalAssinarTitulo from '../components/AppModalAssinarTitulo'
import AppModalVisualizaPdf from '../components/AppModalVisualizaPdf.vue'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import acaoProcesso from '@/constants/acaoProcesso'
import AppModalDespachoPresidente from '../../../screens/analise/components/modal/AppModalDespachoPresidente.vue'
const { showFiltroTipoMultiplo, filtro } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalAssinarTitulo,
    AppModalVisualizarCompleto,
    AppModalVisualizaPdf,
    AppModalDespachoPresidente
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      textoButtonAssinatura: 'Assinar Selecionados',
      textoButtonAssinaturaTodos: 'Assinar Todos',
      isAssinarTodosReurbIndividual: false,
      tiposSelecionados: [],
      isPa: process.env.ESTADO === 'pa',
      situacaoSelecionados: [],
      filtro: null,
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      showButtonAssinaturaGov: false,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      showModalVisualizaPdf: false,
      showModalVisualizarProcesso: false,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      idTitulo: null,
      tipoTitulo: null,
      tituloModal: null,
      conteudoModal: null,
      configuracaoFiltro: {
        filtroSituacaoAssinatura: filtro?.filtroSituacaoAssinatura?.ASSINATURAS || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => this.showGridSelecionavel(), ordem: 1, acoes: [] },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 7, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [], exibir: () => true },
        { id: 8, titulo: 'Área do Imóvel (ha)', propriedade: 'areaImovel', ordem: 5, acoes: [], exibir: () => this.isEstadoMa },
        { id: 8, titulo: 'Situação', propriedade: 'status', ordem: 5, acoes: [], exibir: () => this.isEstadoBa },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Visualizar Título', icone: 'fa-eye', codigo: 'VIZUALIZAR_INFORMACAO', ordem: 1, show: this.showVisualizarTitulo },
            { id: 8, nome: 'Visualizar Errata de Título', icone: 'fa-eye', codigo: 'VIZUALIZAR_ERRATA_TITULO', ordem: 1, show: this.showVisualizarRetificacaoTitulo },
            { id: 3, nome: 'Visualizar Certidão', icone: 'fa-eye', codigo: 'VIZUALIZAR_INFORMACAO', ordem: 1, show: this.showVisualizarCertidao },
            { id: 4, nome: 'Visualizar Ofício', icone: 'fa-eye', codigo: 'VIZUALIZAR_INFORMACAO', ordem: 1, show: this.showVisualizarOficio },
            { id: 4, nome: 'Arquivar Processo', icone: 'fa-archive', codigo: 'ARQUIVAR_PROCESSO', ordem: 1, show: this.showArquivarAssinatura },
            { id: 4, nome: 'Retornar Setor', icone: 'fa-chevron-left', codigo: 'RETORNAR_SETOR', ordem: 1, show: this.showRetornarSetorAssinatura },
            { id: 2, nome: 'Visualizar Extrato Sentença', icone: 'fa-eye', codigo: 'VIZUALIZAR_EXTRATO_SENTENCA', ordem: 1, show: this.showVisualizarExtratoSentenca }
          ]
        }
      ],
      usuario: null,
      openModalDespacho: false,
      acaoAssinatura: null,
      tituloModalDespacho: 'Despacho',
      situacao: '',
      showFiltroTipoMultiplo
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    tipoSelecionado: function () {
      return this.tiposSelecionados[0]
    },
    situacoesIguais () {
      return this.situacaoSelecionados.every(item => item === this.situacaoSelecionados[0])
    },
    desativaBotao () {
      if (process.env.ESTADO === 'ma') {
        var desativo
        desativo = new Set(this.tiposSelecionados).size !== 1 || this.idsProcessosAssinatura.length === 0
        return desativo
      } else if (process.env.ESTADO === 'ba') {
        return !(this.idsProcessosAssinatura.length > 0 && this.situacoesIguais)
      }
    },
    desativaBotaoAssinarTodos () {
      if (process.env.ESTADO === 'ma') {
        return this?.items?.length < 1
      }
      return true
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
    this.filtro = FILTRO_EMPTY()
    this.filtro.caixa = this.$route.name
    if (this.$route.query.processandoAssinaturas) {
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        'Documento(s) sendo assinados pelo GOV.BR, aguarde a finalização!'
      )
    }
    if (this.$route.query.nivelBronze) {
      this.$confirm('É necessário possuir conta gov.br nível prata ou ouro para utilizar o serviço de assinatura', 'Atenção!', {
        confirmButtonText: 'Aumentar Nível',
        type: 'warning'
      }).then(() => {
        window.location.href = this.$route.query.redirectUrl
      }).catch()
    }
    this.getConfiguracao().then(({ assinaturaGovAtiva }) => {
      this.showButtonAssinaturaGov = assinaturaGovAtiva
    })
  },

  watch: {
    async '$route' (to, from) {
      this.filtro.caixa = to.name

      if (this.isEstadoMa() && this.isCaixaAssinatura(to.name) &&
      this.isCaixaAssinatura(from?.name)) {
        this.resetFiltro()
      }

      this.init()
    },

    'situacaoSelecionados' () {
      if (this.situacoesIguais) {
        this.situacao = this.situacaoSelecionados[0]
      } else {
        this.situacao = ''
      }
    }
  },

  methods: {
    ...mapActions({
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      assinarProcessosGov: 'processo/assinarProcessosGov',
      tramitarComAcao: 'processo/tramitarComAcao',
      finalizaAssinatura: 'processo/finalizaAssinatura',
      tarefa: 'processo/tarefa',
      finalizaDespachoAssinatura: 'despacho/finalizaDespachoAssinatura',
      getConfiguracao: 'dados/getConfiguracao'
    }),
    resetFiltro () {
      this.filtro = {
        ...FILTRO_EMPTY(),
        caixa: this.$route.name
      }
    },
    isCaixaAssinatura (routeName) {
      return routeName === 'ASSINATURAS' || routeName === 'ASSINATURAS_REURB'
    },
    showAssinarTodos () {
      const caixa = 'ASSINATURAS_REURB'
      return (this.$route?.name === caixa || this.$route?.fullPath?.includes(caixa)) && this.showAssinarTodosTitulos()
    },
    titleModal () {
      if (this.isEstadoBa && this.situacao === 'AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA') {
        return 'Assinar Extrato de sentença'
      } else {
        return 'Assinar Título'
      }
    },

    async finalizarModalDespachoAssinatura (despacho) {
      this.$confirm(
        'Tem certeza que deseja finalizar a análise?',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(async () => {
          await this.finalizaDespachoAssinatura(despacho)
          this.refresh()
          this.setOpenModal(false)

          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            despacho.acao.includes(acaoProcesso.SOLICITAR_ARQUIVAMENTO) ? 'Encaminhado para arquivamento!' : 'Retornado para o setor anterior!'
          )
        })
        .catch(() => {
        })
    },

    async ARQUIVAR_PROCESSO (_this, {item}) {
      const acoes = await this.tarefa({ processo: item.id })
      const acaoArquivamento = acoes.acoes.find(item => item.valor.includes(acaoProcesso.SOLICITAR_ARQUIVAMENTO))
      this.tipoProcesso = item.tipoCodigo
      if (this.isEstadoMa()) {
        this.idProcesso = item.id
        this.acaoAssinatura = acaoArquivamento?.valor
        this.openModalDespacho = true
        this.tituloModalDespacho = 'Solicitar Arquivamento'
        return
      }

      this.tramitarComAcao({processoId: item.id, acao: acaoArquivamento?.valor}).then(() => {
        this.refresh()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Encaminhado para arquivamento!'
        )
      })
    },
    RETORNAR_SETOR (_this, {item}) {
      if (this.isEstadoMa()) {
        this.idProcesso = item.id
        this.acaoAssinatura = 'RETORNO.SISTEMA.ANTERIOR'
        this.openModalDespacho = true
        this.tituloModalDespacho = 'Retornar Setor'
        return
      }
      this.tramitarComAcao({processoId: item.id, acao: 'RETORNO.SISTEMA.ANTERIOR'}).then(() => {
        this.refresh()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Retornado para o setor anterior!'
        )
      })
    },
    VIZUALIZAR_INFORMACAO (_this, { item }) {
      switch (item.tipoCodigo) {
        case 'CERTIDAO_TITULO':
          this.tituloModal = 'Minuta da Certidão'
          this.tipoTitulo = 'TITULO_CERTIDAO'
          break
        case 'CANCELAMENTO_CLAUSULA_RESOLUTIVA':
          this.tituloModal = 'Minuta do Ofício'
          this.tipoTitulo = 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
          break
        case 'TQ':
        case 'TT':
          this.tituloModal = 'Minuta do Título'
          this.tipoTitulo = 'TITULO_CERTIDAO'
          break
        default:
          this.tituloModal = 'Minuta do Título'
          this.tipoTitulo = 'TITULO_CERTIDAO'
          break
      }

      this.conteudoModal = item.id
      this.showModalVisualizaPdf = true
    },
    VIZUALIZAR_ERRATA_TITULO (_this, { item }) {
      this.tituloModal = 'Minuta da Errata de Título'
      this.tipoTitulo = 'ERRATA_TITULO'
      this.conteudoModal = item.id
      this.showModalVisualizaPdf = true
    },
    VIZUALIZAR_EXTRATO_SENTENCA (_this, { item }) {
      this.tituloModal = 'Extrato de Sentença'
      this.tipoTitulo = 'EXTRATO_SENTENCA'
      this.conteudoModal = item.id
      this.showModalVisualizaPdf = true
    },
    ASSINAR_TODOS_TITULOS () {
      if (this.isEstadoMa()) {
        this.isAssinarTodosReurbIndividual = true
        this.showModalAssinatura = true
      }
    },
    ASSINAR_TITULOS () {
      if (this.isEstadoPa() && this.idsProcessosAssinatura.length === 0) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.SELECIONE_UM_PROCESSO)
        return
      }
      if (this.isEstadoBa()) {
        if (this.situacoesIguais && this.situacaoSelecionados[0] === 'AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA') {
          this.showModalAssinatura = true
          return
        }
        this.$confirm(
          'Ao confirmar, os processos selecionados serão assinados. Tem certeza de que deseja prosseguir com esta ação?',
          'Atenção',
          {
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
          }
        )
          .then(() => {
            this.finalizaAssinatura({ idProcessos: this.idsProcessosAssinatura }).then(() => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, 'Documento assinado', 'Documento(s) assinado(s) com sucesso')
              this.refresh()
            })
          })
          .catch(() => {
          })
        return
      }
      this.showModalAssinatura = true
    },
    ASSINAR_TITULOS_GOV () {
      this.assinarProcessosGov({ idProcessos: this.idsProcessosAssinatura }).then((redirectUrl) => {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Documento(s) adicionados na fila de assinatura, você será redirecionado para a tela autenticação do GOV.BR')
        this.refresh()
        setTimeout(() => {
          window.location.href = redirectUrl
        }, 4000)
      })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    showGridSelecionavel () {
      return this.usuario?.permissoes.find((p) => p?.codigo === 'ASSINAR_TITULO' || p?.codigo === 'ASSINAR_CERTIDAO') !== undefined
    },
    async closeModalAssinatura () {
      if (this.isEstadoBa()) await this.closeModalLimparCamposAssinatura()
      else this.defaultCloseModalAssinatura()
    },
    defaultCloseModalAssinatura () {
      this.isAssinarTodosReurbIndividual = false
      this.showModalAssinatura = false
      this.refresh()
    },
    async closeModalLimparCamposAssinatura () {
      this.idsProcessosAssinatura = []
      this.tiposSelecionados = []
      this.situacaoSelecionados = []
      this.showModalAssinatura = false
      await this.limparAtualizarListagem()
    },
    async atualizarListagem () {
      const itemsAux = [...this.items]
      await this.refresh()
      this.items = [...itemsAux]
    },
    async selectItem (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        const existe = this.idsProcessosAssinatura.find(i => i === item.id)
        if (!existe) {
          this.idsProcessosAssinatura.push(item.id)
          this.tiposSelecionados.push(item.tipoCodigo)
          this.situacaoSelecionados.push(item.codigoStatus)
        }
      } else {
        this.idsProcessosAssinatura = this.idsProcessosAssinatura.filter(i => i !== item.id)
        this.tiposSelecionados = this.tiposSelecionados.length === 1 ? [] : this.tiposSelecionados.splice(this.tiposSelecionados.indexOf(item.tipoCodigo), 1)
        this.situacaoSelecionados.splice(this.situacaoSelecionados.indexOf(item.codigoStatus), 1)
      }
      await this.atualizarListagem()
    },
    selectItems (itens) {
      this.idsProcessosAssinatura = itens.map(item => item.id)
      this.tiposSelecionados = itens.map(item => item.tipo)
      this.processosSelecionados = itens
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()
      this.exportarCsvAnalise(this.filtro)
    },
    isEstadoMa () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoBa () {
      return process.env.ESTADO === 'ba'
    },
    isEstadoPa () {
      return process.env.ESTADO === 'pa'
    },
    isMultiple () {
      return this.isEstadoMa() || this.isEstadoPa()
    },
    setOpenModal (openModal) {
      this.openModalDespacho = openModal
    },
    async limparAtualizarListagem () {
      await this.refresh()
      this.items = this.items.map(item => ({...item, selecionado: false}))
      this.idsProcessosAssinatura = []
      this.tiposSelecionados = []
      this.situacaoSelecionados = []
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.list-table-container {
  position: relative;
}
.buttons-assinatura {
  position: absolute;
  bottom: 20px;
  right: 200px;
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaAssinaturasListagem.vue